import { t } from '../../../i18n'

/**
 * 卡顿时的降档建议。
 *
 * 语气按主流平台来：这是**建议**，不是报错——网络不好不是用户做错了什么，
 * 也不是我们的片子坏了。给一个一键照做，和一个「不用管」。
 *
 * 只在用户自己定过档时才会出现（见 Player 的 onWaiting）。
 */
export function StallHint({ onAccept, onDismiss }: { onAccept: () => void; onDismiss: () => void }) {
  return (
    <div style={hint.wrap}>
      <div style={hint.text}>
        <strong style={hint.title}>{t.quality.stallTitle}</strong>
        <span style={hint.body}>{t.quality.stallBody}</span>
      </div>
      <button style={hint.accept} onClick={onAccept}>
        {t.quality.stallAction}
      </button>
      <button style={hint.dismiss} onClick={onDismiss} aria-label={t.quality.stallDismiss}>
        ✕
      </button>
    </div>
  )
}

const hint = {
  wrap: {
    // 不自己定位：它和「点一下开声音」都要待在底部那一摞里，
    // 各自绝对定位的话迟早叠在一起。
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '10px 12px',
    borderRadius: 12,
    background: 'rgba(0,0,0,.78)',
  },
  text: { flex: 1, display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 },
  title: { fontSize: 13 },
  body: { fontSize: 12, color: 'var(--text-dim)' },
  accept: {
    flex: '0 0 auto',
    padding: '7px 14px',
    borderRadius: 100,
    background: 'var(--accent)',
    color: '#fff',
    fontSize: 13,
  },
  dismiss: { flex: '0 0 auto', padding: 4, fontSize: 13, color: 'var(--text-dim)', background: 'transparent' },
} satisfies Record<string, React.CSSProperties>

/**
 * 「已切换到 540P」。
 *
 * 换档要等缓冲里的旧片段播完、新档的片段下回来，画面好几秒后才变。
 * 这几秒里什么都不说的话，人会以为没点中，然后反复点。
 */
export function QualityToast({ label }: { label: string }) {
  return <div style={toast.wrap}>{t.quality.switched.replace('{q}', label)}</div>
}

const toast = {
  wrap: {
    alignSelf: 'center',
    padding: '8px 16px',
    borderRadius: 100,
    background: 'rgba(0,0,0,.72)',
    fontSize: 13,
  },
} satisfies Record<string, React.CSSProperties>
